<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h1 class="toc-title">CONTENTS</h1>
<h2 class="toc1"><a href="#/xhtml/04_Preface#pre"><span class="bold">Preface &amp; Acknowledgements</span></a></h2>
<h2 class="toc1"><a href="#/xhtml/05_Intro#intro"><span class="bold">Introduction</span></a></h2>
<h2 class="toc1"><a href="#/xhtml/06_Engineers#eng"><span class="bold">The Engineers</span></a></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter01#chapter1" title="Link target outside of Sample"><span class="tochang">Chapter 1</span> <span class="bold">The Barry Railway</span></span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02#chapter2" title="Link target outside of Sample"><span class="tochang">Chapter 2</span> <span class="bold">The Cardiff Railway</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03#chapter3" title="Link target outside of Sample"><span class="tochang">Chapter 3</span> <span class="bold">The Brecon &amp; Merthyr Railway</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04#chapter4" title="Link target outside of Sample"><span class="tochang">Chapter 4</span> <span class="bold">The Rhymney Railway</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05#chapter5" title="Link target outside of Sample"><span class="tochang">Chapter 5</span> <span class="bold">The Taff Vale Railway</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06#chapter6" title="Link target outside of Sample"><span class="tochang">Chapter 6</span> <span class="bold">Other South Wales Companies</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07#chapter7" title="Link target outside of Sample"><span class="tochang">Chapter 7</span> <span class="bold">The Great Western 56XX &amp; 66XX</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08#chapter8" title="Link target outside of Sample"><span class="tochang">Chapter 8</span> <span class="bold">Preserved Locomotives</span></span></h2>
<h2 class="toc1a"><span href="#/xhtml/15_Appendix#appen" title="Link target outside of Sample"><span class="bold">Appendix</span></span></h2>
<h2 class="toc1"><span href="#/xhtml/16_Bib#bib" title="Link target outside of Sample"><span class="bold">Bibliography</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?69eb06fc